import { css, Interpolation, Theme } from '@emotion/react'

export const labelWrapper: Interpolation<Theme> = (theme) => css`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
`

export const optionsWrapper: Interpolation<Theme> = (theme) => css`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .MuiButtonBase-root {
    margin: 0 10px;
  }

  .MuiTypography-root {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.typographyColors.typographyThree};
  }
`

export const buttonsWrapper: Interpolation<Theme> = css`
  display: flex;
  justify-content: space-between;
  gap: 10px;

  & > div {
    display: flex;
    gap: 10px;
  }
`
